import { adminAPIService, adminFileDownloadService } from './index'

const route = 'rewardsnap'

export const getPaymentStatusUploadHistoryList = (is_campaign = 0, page = 1, size = 20) => {
  const params = {
    is_campaign,
    page,
    size,
  }

  return adminAPIService({
    url: `${route}/orders/payment-status`,
    method: 'get',
    params,
  })
}

export const uploadPaymentStatus = (file, is_campaign = 0) => {
  const formData = new FormData()
  formData.append('csv', file)
  formData.append('is_campaign', is_campaign)

  return adminAPIService({
    url: `${route}/orders/payment-status`,
    method: 'post',
    data: formData,
  })
}

export const getCampaignPaymentUsers = ioNumber => adminAPIService({
  url: `${route}/campaigns/${ioNumber}`,
  method: 'get',
})

export const updateCampaignPayment = (campaignId, userId, {
  paymentMethod,
  currency,
  amount,
  paypalTransactionId,
  payoutDate,
}) => {
  let body = `payment_type=${paymentMethod}` +
  `&currency=${currency}` +
  `&amount=${amount}` +
  `&payout_date=${payoutDate}`

  if (paypalTransactionId) {
    body += `&paypal_transaction_id=${paypalTransactionId}`
  }

  return adminAPIService({
    url: `${route}/campaigns/${campaignId}/users/${userId}`,
    method: 'post',
    data: body,
  })
}

export const deleteCampaignOrder = (campaignId, userId) => {
  return adminAPIService({
    url: `${route}/campaigns/${campaignId}/users/${userId}/delete`,
    method: 'post',
  })
}

export const getPendingPayments = (page = 1, size = 20) => {
  const params = {
    page,
    size,
  }

  return adminAPIService({
    url: `${route}/orders/pending-payment`,
    method: 'get',
    params,
  })
}

export const generatePendingPaymentsCsv = () => adminFileDownloadService({
  url: `${route}/orders/pending-payment`,
  method: 'get',
  headers: {
    'Content-Type': 'text/csv',
  },
  data: {}, // https://github.com/axios/axios/issues/86#issuecomment-139638284
})
